

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const SENDOTP= createAsyncThunk(
  "sendOTP/sendOTP",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const sendOTPSlice = createSlice({
  name: "sendOTPSlice",
  initialState: {
    sendOTP: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsendOTP: (state) => {
        state.sendOTP.loading = false
        state.sendOTP.error = false
        state.sendOTP.data = []
        state.sendOTP.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SENDOTP.fulfilled, (state, action) => {
      state.sendOTP = {
        ...state.sendOTP,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SENDOTP.pending, (state, action) => {
      state.sendOTP = {
        ...state.sendOTP,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SENDOTP.rejected, (state, action) => {
      state.sendOTP = {
        ...state.sendOTP,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const sendOTPAction = {
    SENDOTP,
};

export { sendOTPAction };
export default sendOTPSlice.reducer;
export const {setInitialStateOfsendOTP} = sendOTPSlice.actions
